import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Instagram, Facebook, Star, Download } from "lucide-react";

const ASSET_BASE = `${process.env.PUBLIC_URL || ""}/assets`;

export default function Footer() {
  return (
    <footer className="relative mt-24 bg-mint text-choc rounded-t-[3rem] pt-20 pb-32 md:pb-20 overflow-hidden" data-testid="footer">
      <div className="absolute -top-1 left-0 right-0 dotted-divider opacity-30" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4 space-y-5">
          <img src={`${ASSET_BASE}/logo.png`} alt="Holiday Ice Creams" className="h-20 w-auto" />
          <p className="text-sm leading-relaxed text-choc/80 max-w-sm">
            Established 1999. Slow-cooked, hand-folded ice creams from Gorakhpur — open every hour of every day.
          </p>
          <div className="flex items-center gap-2 sticker bg-holiday-red text-white">
            <Clock className="w-3.5 h-3.5" /> Open 24 hours
          </div>
        </div>

        <div className="md:col-span-3 space-y-3">
          <h4 className="font-display text-2xl">Visit</h4>
          <p className="text-sm leading-relaxed text-choc/85">
            Road No.12, G‑23, near Springer School, behind Ramada Hotel, Lachhipur Industrial Area, Dayanand Nagar,
            <br/>Gorakhpur, UP 273015
          </p>
          <a href="https://maps.app.goo.gl/xd1he1c7UpNeaTuV9" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-sm font-semibold underline" data-testid="footer-maps-link">
            <MapPin className="w-4 h-4" /> Open in Google Maps
          </a>
        </div>

        <div className="md:col-span-3 space-y-3">
          <h4 className="font-display text-2xl">Reach us</h4>
          <ul className="space-y-1.5 text-sm">
            <li><a className="hover:text-holiday-red flex items-center gap-2" href="tel:9235372759" data-testid="footer-phone-1"><Phone className="w-3.5 h-3.5"/> 9235372759</a></li>
          </ul>
          <a className="hover:text-holiday-red flex items-center gap-2 text-sm" href="mailto:harshicepartner@gmail.com" data-testid="footer-email-1">harshicepartner@gmail.com</a>
          <div className="flex gap-2 pt-1">
            <a href="https://instagram.com/" target="_blank" rel="noreferrer" className="bg-cream hover:bg-ice-pink p-2.5 rounded-full transition-colors" data-testid="social-instagram">
              <Instagram className="w-4 h-4"/>
            </a>
            <a href="https://facebook.com/" target="_blank" rel="noreferrer" className="bg-cream hover:bg-ice-pink p-2.5 rounded-full transition-colors" data-testid="social-facebook">
              <Facebook className="w-4 h-4"/>
            </a>
            <a href="https://maps.app.goo.gl/xd1he1c7UpNeaTuV9" target="_blank" rel="noreferrer" className="bg-cream hover:bg-ice-pink p-2.5 rounded-full transition-colors" data-testid="social-google">
              <Star className="w-4 h-4"/>
            </a>
          </div>
        </div>

        <div className="md:col-span-2 space-y-3">
          <h4 className="font-display text-2xl">Quick</h4>
          <ul className="space-y-1.5 text-sm">
            <li><Link className="hover:text-holiday-red" to="/products">Products</Link></li>
            <li><Link className="hover:text-holiday-red" to="/flavours">Flavours</Link></li>
            <li><Link className="hover:text-holiday-red" to="/bulk-order">Bulk Order</Link></li>
            <li><Link className="hover:text-holiday-red" to="/grow-with-us">Grow with us</Link></li>
            <li><Link className="hover:text-holiday-red" to="/contact">Contact</Link></li>
          </ul>
          <button className="inline-flex items-center gap-1.5 text-xs font-semibold text-choc/70 hover:text-holiday-red" data-testid="footer-pdf-btn" onClick={() => document.querySelector('[data-testid="share-catalogue-trigger"]')?.click()}>
            <Download className="w-3.5 h-3.5"/> Share / Download Catalogue
          </button>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 pt-6 border-t border-choc/10 flex flex-wrap items-center justify-between gap-3 text-xs text-choc/70">
        <p>© {new Date().getFullYear()} Holiday Ice Creams · Gorakhpur</p>
        <p className="flex items-center gap-1.5"><Star className="w-3.5 h-3.5 fill-sun-yellow text-sun-yellow"/> 4.9 · 31 Google Reviews</p>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-3 text-center text-[11px] text-choc/55" data-testid="footer-credits">
        Designed &amp; developed by{" "}
        <a href="https://www.saminfratech.com" target="_blank" rel="noreferrer" className="font-semibold text-choc/80 hover:text-holiday-red underline underline-offset-2">
          Saminfratech
        </a>
        {" "}— stirred with cream, cardamom &amp; a scoop of love.
      </div>
    </footer>
  );
}



